"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fix_parent_1 = require("./fix$parent");
var funcParams_1 = require("./funcParams");
var cacheFuncs = {};
function validFunction(schema, cache, debug) {
    if (cache === void 0) { cache = true; }
    var func = null;
    if (schema.validFunc) {
        if (cache && !debug) {
            func = cacheFuncs['valid_' + schema.validFunc];
            if (func !== undefined) {
                return func;
            }
        }
        var stext = fix_parent_1.default(schema.validFunc);
        // let ftext = '';
        if (stext.indexOf('{') === -1) {
            stext = "{$result=(" + stext + ")}";
        }
        var ffunc = "var $value=$obj.$model;\r\nvar $result=null;\r\n" + stext + ";";
        // ffunc+=`${}`;
        // ffunc += 'with($data) {';
        // ffunc += `with(parent) ${stext};`;
        // ffunc += '};';
        // ffunc += `console.log('validFuncResult','${propName}',$result);`;
        ffunc += '\r\nreturn $result;';
        if (debug) {
            ffunc = 'console.dbug($obj.$path);\r\ndebugger;\r\n' + ffunc;
        }
        // old
        /*
        ftext += `return (${stext});`;



        if (debug && !debug) {
            ftext = 'debugger;\r\n' + ftext;
        }
        */
        func = new Function(funcParams_1.default, ffunc);
        if (cache) {
            cacheFuncs['valid_' + schema.validFunc] = func;
        }
    }
    return func;
}
exports.default = validFunction;
//# sourceMappingURL=validFunction.js.map